import React from 'react';
import { Zap } from 'lucide-react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-clkk-dark border-b border-clkk-gray-800 p-4 flex justify-between items-center shadow-lg backdrop-blur-sm">
      <div className="flex items-center space-x-2">
        <Zap className="w-8 h-8 text-transparent bg-gradient-brand bg-clip-text" />
        <h1 className="text-2xl font-bold text-transparent bg-gradient-brand bg-clip-text">CLKK</h1>
      </div>
      {auth.currentUser ? (
        <button 
          onClick={handleSignOut} 
          className="px-4 py-2 rounded-lg bg-gradient-brand hover:opacity-90 transition-opacity text-sm font-medium"
        >
          Sign Out
        </button>
      ) : (
        <button 
          onClick={() => navigate('/signin')} 
          className="px-4 py-2 rounded-lg bg-gradient-brand hover:opacity-90 transition-opacity text-sm font-medium"
        >
          Sign In
        </button>
      )}
    </header>
  );
};

export default Header;